import React, { useEffect } from "react";
import { integrityStyles } from "./integrityTheme";
import { CONTACT_EMAIL } from "./offers";
import { setMeta } from "./seo";
import SiteFooter from "./SiteFooter";

const sections = [
  {
    h: "Who we are",
    p: [
      "Documore LLC (\"Documore\", \"we\") provides data, document and AI verification services. This policy explains what information we collect through this website and how we handle data clients send us during an engagement.",
    ],
  },
  {
    h: "Information from this website",
    p: [
      "When you use our contact form we receive the name, work email, company and message you enter. We use it only to reply to you and discuss your request.",
      "We use Google Analytics and Google Tag Manager to understand how the site is used. These tools set cookies and collect usage data such as pages visited and approximate location. Advertising storage is disabled by default.",
    ],
  },
  {
    h: "Client data during an engagement",
    p: [
      "Data you send us for an engagement (for example lead lists, CRM exports, documents or call recordings) is used only to perform that engagement.",
      "We never use client data to train AI models, never combine it with another client's data, and never sell or share it, except with service providers needed to perform the work (for example email verification, data verification and hosting providers), under their own confidentiality and security terms.",
      "Client data is deleted within 30 days of acceptance of the deliverables, unless you ask us in writing to delete it sooner or keep it longer.",
      "Please do not send payment card numbers, bank account numbers, government ID numbers or health information unless we have signed a specific agreement covering that data.",
    ],
  },
  {
    h: "Security",
    p: [
      "Client data is stored in access-controlled cloud storage, separated per client, and access is limited to the people performing the work.",
    ],
  },
  {
    h: "Your choices and requests",
    p: [
      `To access, correct or delete information we hold about you, or to stop receiving emails from us, contact ${CONTACT_EMAIL}. Every email we send includes a way to opt out, and opt-outs are honored promptly.`,
    ],
  },
  {
    h: "Changes",
    p: ["We may update this policy. The effective date below shows when it last changed."],
  },
];

export default function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
    setMeta({
      title: "Privacy — Documore",
      description: "How Documore handles website data and client data during engagements.",
      url: "https://documore.com/privacy",
    });
  }, []);

  return (
    <>
      <style>{integrityStyles}</style>
      <div className="di-root">
        <div className="di-wrap di-section" style={{ maxWidth: 820 }}>
          <div className="di-kicker">
            <span className="di-kicker-line" />
            <span className="di-kicker-text">Privacy policy</span>
          </div>
          <h1 className="di-h1" style={{ marginBottom: 12 }}>Privacy</h1>
          <p className="di-text" style={{ marginBottom: 40 }}>Effective October 2026</p>
          {sections.map((s) => (
            <section key={s.h} style={{ marginBottom: 32, display: "grid", gap: 12 }}>
              <h2 className="di-h3">{s.h}</h2>
              {s.p.map((t) => <p key={t} className="di-text">{t}</p>)}
            </section>
          ))}
          <p className="di-text">
            Contact: <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          </p>
        </div>
        <SiteFooter />
      </div>
    </>
  );
}
